export enum FeatureFlag {
  AdvisorOnboarding = 'flagAdvisorOnboarding',
  CockpitNonEci = 'flagCockpitNonEci',
  AdvisorDirectory = 'flagAdvisorDirectory',
  AiExperienceOptIn = 'ai_experience_opt_in',
  ClientPortalRedesignAccountProfile = 'flagClientPortalRedesignAccountProfile',
  ClientPortalRedesignAccounts = 'flagClientPortalRedesignAccounts',
  ClientPortalRedesignDocuments = 'flagClientPortalRedesignDocuments',
  ClientPortalRedesignHome = 'flagClientPortalRedesignHome',
  ClientPortalRedesignInvestments = 'flagClientPortalRedesignInvestments',
  ClientPortalRedesignOnboarding = 'flagClientPortalRedesignOnboarding',
  ClientPortalRedesignPlanning = 'flagClientPortalRedesignPlanning',
  ClientPortalRedesignShell = 'flagClientPortalRedesignShell',
  ClientPortalRedesignTasks = 'flagClientPortalRedesignTasks',
  ClientPortalRedesignTax = 'flagClientPortalRedesignTax',
  ClientPortalRedesignYourTeam = 'flagClientPortalRedesignYourTeam',
  ExtendDocumentExtractionPollingEnabled = 'flagExtendDocumentExtractionPollingEnabled',
  FlagServalSupport = 'flagServalSupport',
  GoldmanSachsCustodian = 'flagGoldmanSachsCustodian',
  InvestmentProposalsUploadFile = 'investmentProposalsUploadFile',
  LinkedBankAdvisorImport = 'flagLinkedBankAdvisorImport',
  ManagedInvestmentsImprovements = 'managedInvestmentsImprovements',
  ProfessionalContacts = 'flagProfessionalContacts',
  RetirementPlans = 'flagRetirementPlans',
  ServiceItems = 'service-items',
  SkewAutoReload = 'flagSkewAutoReload',
}
